module.exports = __webpack_public_path__ + "img/jo2.0d2e9e06.png";